<template>
    <div class="radio-group">
      <slot></slot>
    </div>
</template>

<script>
    export default {
      componentName: "RadioGroup",
      props: {
        input: {}
      },
      model: {
        prop: "input",
        event: "input"
      },
      watch: {
        input: {
          handler(val) {
            this.model = val
          },
          deep: true
        }
      },
      data() {
        return {model: this.input}
      },
      methods: {
        exist(value, valueKey) {
          if (valueKey) {
            return this.model[valueKey] === value[valueKey]
          } else {
            return this.model === value
          }
        },
        change(value) {
          this.model = value;
          this.$emit("input", this.model);
        }
      }
    }
</script>




// WEBPACK FOOTER //
// src/components/form/RadioGroup.vue